module.exports = __webpack_public_path__ + "assets/img/logo.74abedd5.png";